import { useProjectId } from "hooks/useProjectId";
import classes from "./classes.module.scss";
import CreativeSourceResponseResource from "common/resources/Project/Config/CreativeSource/CreativeSourceResponseResource";
import { useEffect, useState } from "react";
import { container } from "tsyringe";
import CreativeSourceService from "services/projects/CreativeSourceService";
import LazyImage from "components/elements/LazyImage";
import Typography from "components/elements/Typography";
import { translateISO369 } from "utils/I18nText";

const creativeSourceService = container.resolve(CreativeSourceService);

type IProps = {
	creativeSource: CreativeSourceResponseResource;
};

export default function ProjectCreativeSource(props: IProps) {
	const { imageUrl } = useCreativeSource(props.creativeSource);

	return (
		<div className={classes["root"]}>
			{imageUrl && <LazyImage src={imageUrl} alt="Creative Source" className={classes["image"]} />}
			<Typography type="p" weight="medium" size="small" color="inherit" className={classes["description"]}>
				{translateISO369(props.creativeSource.description)}
			</Typography>
		</div>
	);
}

const useCreativeSource = (creativeSource: Pick<CreativeSourceResponseResource, "id" | "image">) => {
	const { projectId } = useProjectId();
	const [imageUrl, setImageUrl] = useState<string | null>(null);

	useEffect(() => {
		if (!creativeSource.image) return;
		creativeSourceService.downloadImage(projectId, creativeSource.id).then((blob) => setImageUrl(URL.createObjectURL(blob)));
	}, [projectId, creativeSource]);

	return { imageUrl };
};
